module.exports = __webpack_public_path__ + "img/logo2.e1325a99.png";